<div class="ppLogin_content">
  <div class="ppLogin_body">
    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
      <div class="loginBody-content">
        <div class="vjOTPVerfication">
          <h4>{{ 'MODULES.LOGIN.OTP_VERIFICATION' | transloco }}</h4>
          <p>{{ 'MODULES.LOGIN.OTP_SENT_TO_EMAIL' | transloco }}
          <p class="vjOTPVerfication_mail"><b> {{ maskedEmail || resetPasswordUsername }}</b></p>
          <div class="vjOTPVerfication_otp">
            <div class="dsFieldWrap">
              <mat-form-field>
                <input matInput formControlName="otp1" maxlength="1" (keyup)="moveToNext($event, otp2, otp1)" #otp1 />
              </mat-form-field>
              <mat-form-field>
                <input matInput formControlName="otp2" maxlength="1" (keyup)="moveToNext($event, otp3, otp1)" #otp2 />
              </mat-form-field>
              <mat-form-field>
                <input matInput formControlName="otp3" maxlength="1" (keyup)="moveToNext($event, otp4, otp2)" #otp3 />
              </mat-form-field>
              <mat-form-field>
                <input matInput formControlName="otp4" maxlength="1" (keyup)="moveToNext($event, otp5, otp3)" #otp4 />
              </mat-form-field>
              <mat-form-field>
                <input matInput formControlName="otp5" maxlength="1" (keyup)="moveToNext($event, otp6, otp4)" #otp5 />
              </mat-form-field>
              <mat-form-field>
                <input matInput formControlName="otp6" maxlength="1" (keyup)="moveToNext($event, otp6, otp5)" #otp6 />
              </mat-form-field>
              <div class="dsErrorMsg" *ngIf="confirmationCodeEntered()">
                <ng-container>
                  {{ 'MODULES.LOGIN.CONFIRMATION_CODE_REQUIRED' | transloco }}
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="login-options verifyPass">
          <div class="login-options-link">
            <span>{{ 'MODULES.LOGIN.DIDNT_RECEIVE_CODE' | transloco }}</span>
            <a class="dsLink" (click)="resendConfirmationCode()"><span class="dsLink_line">{{ 'MODULES.LOGIN.RESEND' |
                transloco }}</span></a>
          </div>
        </div>
        <div class="dsFieldWrap">
          <div class="dsLabel">{{ 'MODULES.LOGIN.NEW_PASSWORD' | transloco }}<sup class="dsAsterix">*</sup></div>
          <mat-form-field appearance="outline" floatLabel="never">
            <input [type]="showPassword ? 'text' : 'password'" matInput required formControlName="newPassword" />
            <span (click)="showPassword = !showPassword" class="eye loginIcon" [ngClass]="{
                    'icon-pswdHide': !showPassword,
                    'icon-pswdShow': showPassword
                  }"></span>
          </mat-form-field>
          <ng-container
            *ngIf="changePasswordForm.get('newPassword').invalid && changePasswordForm.get('newPassword').touched">
            @if (changePasswordForm.get('newPassword').errors?.required) {
            <div class="dsErrorMsg">
              {{ 'MODULES.ACCOUNT_SECURITY.CHANGE_PASSWORD_LABELS.MESSAGES.NEW_PASSWORD_EMPTY_ERROR_TWO' | transloco }}
            </div>
            } @else if (changePasswordForm.get('newPassword').errors?.mininumLengthRequiredError) {
            <div class="dsErrorMsg">
              {{ 'MODULES.ACCOUNT_SECURITY.CHANGE_PASSWORD_LABELS.MESSAGES.NEW_PASSWORD_MINIMUN_LENGTH_ERROR_TWO' |
              transloco }}
            </div>
            } @else if (changePasswordForm.get('newPassword').errors?.pattern) {
            <div class="dsErrorMsg">
              {{ 'MODULES.ACCOUNT_SECURITY.CHANGE_PASSWORD_LABELS.MESSAGES.NO_SPACES_ALLOWED' | transloco }}
            </div>
            } @else if (changePasswordForm.get('newPassword').errors?.passwordStrengthError) {
            <div class="dsErrorMsg multiLineError">
              {{ 'MODULES.ACCOUNT_SECURITY.CHANGE_PASSWORD_LABELS.MESSAGES.NEW_PASSWORD_REQUIRED_PATTERN_ERROR' |
              transloco }}
            </div>
            }
          </ng-container>
        </div>
        <div class="dsFieldWrap">
          <div class="dsLabel">{{ 'MODULES.LOGIN.CONFIRM_PASSWORD' | transloco }}<sup class="dsAsterix">*</sup></div>
          <mat-form-field appearance="outline" floatLabel="never">
            <input [type]="showConfirmPassword ? 'text' : 'password'" matInput required
              formControlName="confirmPassword" />
            <span (click)="showConfirmPassword = !showConfirmPassword" class="eye loginIcon" [ngClass]="{
                    'icon-pswdHide': !showConfirmPassword,
                    'icon-pswdShow': showConfirmPassword
                  }"></span>
          </mat-form-field>
          <ng-container *ngIf="changePasswordForm.get('confirmPassword').invalid &&
                changePasswordForm.get('confirmPassword').touched">
            @if (changePasswordForm.get('confirmPassword').errors?.required) {
            <div class="dsErrorMsg">
              {{ 'MODULES.ACCOUNT_SECURITY.CHANGE_PASSWORD_LABELS.MESSAGES.CONFIRM_PASSWORD_EMPTY_ERROR_TWO' | transloco
              }}
            </div>
            } <!-- @else if (changePasswordForm.get('confirmPassword').errors?.mininumLengthRequiredError) {
            <div class="dsErrorMsg">
              {{ 'MODULES.ACCOUNT_SECURITY.CHANGE_PASSWORD_LABELS.MESSAGES.CONFIRM_PASSWORD_MINIMUN_LENGTH_ERROR_TWO' |
              transloco }}
            </div>
            } --> @else if (changePasswordForm.get('confirmPassword').errors?.passwordValueMismatch) {
            <div class="dsErrorMsg">
              {{ 'MODULES.ACCOUNT_SECURITY.CHANGE_PASSWORD_LABELS.MESSAGES.PASSWORD_MATCH_ERROR_TWO' | transloco }}
            </div>
            }
          </ng-container>
        </div>
      </div>
      <footer class="loginBody-footer">
        <button type="submit" class="loginAction_btn">
          {{ 'MODULES.LOGIN.CHANGE_PASSWORD' | transloco }}
        </button>
        <div class="login-options">
          <div class="login-options-link">
            <span>{{ 'MODULES.LOGIN.ALREADY_HAVE_LOGIN_AND_PASSWORD' | transloco }}</span>
            <a class="dsLink" (click)="goToSignIn()"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_IN' | transloco
                }}</span></a>
          </div>
        </div>
      </footer>
    </form>
  </div>
  <div class="login-copyright">
    {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
  </div>
</div>